import * as React from 'react';
import * as _ from 'lodash';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { Dispatch, connect } from "react-redux";
import { GridApi, ColumnApi, GridReadyEvent } from 'ag-grid-community';
import { IListItem, IDonorShieldDirect, IDonorShieldDirectCounts, IDonorShieldDirectAddEdit, IWatrRequest, IWatrReimbursement } from '@nkr/models/index';
import { IApplicationState, AppActionCreators, IAppState, DonorShieldDirectActionCreators, IDonorShieldDirectResponse, IDonorShieldDirectListResponse, IDonorShieldDirectRequestCountsResponse, IWatrRequestUpdateResponse, WatrActionCreators, FileActionCreators, IWatrAuditLogResponse, IReimbursementEntryResponse, IReimbursementUpdateResponse, IWatrDetailsDataResponse, IWatrRequestLookupDataResponse } from '@nkr/store/index';
import { DonorShieldDirectCategory, DonorShieldDirectViewType, FileDocumentType, OrganType, WageAndTravelStatus, WageAndTravelType, WageAndTravelViewType } from '@nkr/enums/index';
import Filters from './filters';
import Grid from './grid';
import DeleteConfirmation from './delete-confirmation';
import Sidebar from '../watr/components/sidebar';
import MediaQuery from 'react-responsive';
import AdditionalInfoSidebar from '../watr/components/additional-info-sidebar';
import { DonorShieldProvider, IDonorShieldContext } from '../watr/components/context';
import { IWatrUpdateDonorRequest } from '@nkr/store/watr/actions';

const tabMap = [
    { id: DonorShieldDirectCategory.PendTrans, section: 'PENDING-TRANSPLANT' },
    { id: DonorShieldDirectCategory.Transplanted, section: 'TRANSPLANTED' },
    { id: DonorShieldDirectCategory.AddDonor, section: 'ADD-DONOR' },
    { id: DonorShieldDirectCategory.EditDonor, section: 'EDIT-DONOR' },
    { id: DonorShieldDirectCategory.UploadLostWage, section: 'UPLOAD-LOST-WAGE' }
];

interface IProps {
    centerId: number,
    donorRecordId: number,
    isSuperUser: boolean,
    section: string
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getDonorShieldDirectCounts: (centerId: number, isAdmin: boolean, organType: number) => Promise<IDonorShieldDirectRequestCountsResponse>,
    getDonorShieldDirectList: (centerId: number, matchStatus: number, isAdmin: boolean, organType: number) => Promise<IDonorShieldDirectListResponse>,
    addDonorShieldDirectRecord: (dsdData: IDonorShieldDirectAddEdit) => Promise<IDonorShieldDirectResponse>,
    updateDonorShieldDirectRecord: (donorShieldId: number, dsdData: IDonorShieldDirectAddEdit) => Promise<IDonorShieldDirectResponse>,
    deleteDonorShieldDirectRecord: (donorShieldId: number) => Promise<IDonorShieldDirectListResponse>,
    updateDonorRequest: (request: IWatrUpdateDonorRequest) => Promise<IWatrRequestUpdateResponse>,
    downloadFile: (docType: number, lookupId: number) => Promise<any>,
    saveLogEntry: (requestId: number, type: number, comments: string, file: File) => Promise<IWatrAuditLogResponse>,
    updateLogEntry: (requestId: number, logId: number, type: number, comments: string, file: File) => Promise<IWatrAuditLogResponse>,
    deleteLogEntry: (requestId: number, logId: number) => Promise<IWatrAuditLogResponse>,
    saveReimbursementEntry: (requestId: number, type: number, amount: number, confirmationCode: string, date: string) => Promise<IReimbursementEntryResponse>,
    updateReimbursement: (requestId: number, reimbursementId: number, type: number, amount: number, confirmationCode: string, date: string) => Promise<IReimbursementUpdateResponse>,
    getTravelDetails: (centerId: number, requestId: number, isAdmin: boolean) => Promise<IWatrDetailsDataResponse>,
    getRequestLookupData: (centerId: number, isSuperUser: boolean) => Promise<IWatrRequestLookupDataResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    donationTypes: IListItem[],
    requestTypes: IListItem[],
    statusTypes: IListItem[],
    auditLogTypes: IListItem[],
    logActionTypes: IListItem[],
    reimbursementTypes: IListItem[],
    list: IDonorShieldDirect[],
    isLoadingList: boolean,
    counts: IDonorShieldDirectCounts,
    organTypes: IListItem[],
    states: IListItem[],
    insuranceTypes: IListItem[],
    category: DonorShieldDirectCategory,
    modal: {
        show: boolean,
        data: IDonorShieldDirect,
        type: DonorShieldDirectViewType
    },
    delete: {
        show: boolean,
        data: IDonorShieldDirect
    },
    container: {
        show: boolean,
        data: IWatrRequest,
        reimbursements: IWatrReimbursement[]
    },
    additionalInfoSidebar: {
        show: boolean,
        data: IWatrRequest,
        // fileType: number,
        // fileRequestId: number,
        fileUrl: string,
        displayType: FileDocumentType
    },
}

class DonorShieldDirect extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        isLoadingList: true,
        counts: null,
        organTypes: [],
        donationTypes: [],
        requestTypes: [],
        statusTypes: [],
        auditLogTypes: [],
        logActionTypes: [],
        reimbursementTypes: [],
        states: [],
        insuranceTypes: [],
        category: DonorShieldDirectCategory.Transplanted,
        modal: {
            show: false,
            data: null,
            type: null
        },
        delete: {
            show: false,
            data: null
        },
        container: {
            show: false,
            data: null,
            reimbursements: null
        },
        additionalInfoSidebar: {
            show: false,
            data: null,
            displayType: null,
            fileUrl: ''
        }
    }

    gridApi: GridApi = null;
    columnApi: ColumnApi;

    container: HTMLDivElement;
    intervalId: any;

    componentDidMount = () => {
        let category = DonorShieldDirectCategory.PendTrans;

        let c = tabMap.find(x => x.section == this.props.section);

        if (c != null) {
            category = c.id;
        }

        this.getData(category, true);
    }

    getData = (category: DonorShieldDirectCategory, message: boolean) => {
        let shouldGetList = category != DonorShieldDirectCategory.AddDonor
            && category != DonorShieldDirectCategory.EditDonor
            && category != DonorShieldDirectCategory.UploadLostWage;

        // The grid shows its own loading overlay while the list is being fetched,
        // so the global spinner is only needed for the no-grid categories below.
        let start = (message && !shouldGetList) ? this.props.showLoading('Getting donor shield records, one moment please...') : Promise.resolve(null);

        let organType = this.props.app.site.organType == OrganType.Kidney ? null : this.props.app.site.organType;

        if (shouldGetList) {
            this.setState({ isLoadingList: true });
        }

        start.then(() => {
            if (shouldGetList) {
                return Promise.all([
                    this.props.getDonorShieldDirectCounts(this.props.centerId, this.props.isSuperUser, organType),
                    this.props.getDonorShieldDirectList(this.props.centerId, category, this.props.isSuperUser, organType),
                    this.props.getRequestLookupData(this.props.centerId, this.props.isSuperUser)
                ])
                    .then(([countsResponse, listResponse, lookupDataResponse]) => {
                        if (countsResponse.data.success && listResponse.data.success && lookupDataResponse.data.success) {
                            let counts = countsResponse.data.results;
                            let list = listResponse.data.results;

                            list.forEach(x => {
                                if (x.watrRequest != null) {
                                    x.watrRequest.alias = x.donorAlias;
                                }
                            })

                            let { donationTypes, requestTypes, statusTypes, reimbursementTypes, auditLogTypes, logActionTypes } = lookupDataResponse.data.results;

                            this.setState({
                                list,
                                category,
                                counts,
                                donationTypes,
                                requestTypes,
                                statusTypes,
                                reimbursementTypes,
                                auditLogTypes,
                                logActionTypes: logActionTypes || [],
                            });
                        }
                    }).finally(() => {
                        this.setState({ isLoadingList: false });
                    });
            } else {
                return Promise.all([
                    this.props.getDonorShieldDirectCounts(this.props.centerId, this.props.isSuperUser, organType),
                    this.props.getRequestLookupData(this.props.centerId, this.props.isSuperUser)
                ])
                    .then(async ([countsResponse, lookupDataResponse]) => {
                        if (countsResponse.data.success && lookupDataResponse.data.success) {
                            let counts = countsResponse.data.results;
                            let { donationTypes, requestTypes, statusTypes, reimbursementTypes, auditLogTypes, logActionTypes } = lookupDataResponse.data.results;

                            this.setState({
                                category,
                                counts,
                                donationTypes,
                                requestTypes,
                                statusTypes,
                                reimbursementTypes,
                                auditLogTypes,
                                logActionTypes: logActionTypes || [],
                            });
                        }

                        this.props.hideLoading();
                    });
            }
        });
    }

    getTotal = () => {
        if (this.state.counts != null) {
            let { pendingTransplantTotal, transplantedTotal } = this.state.counts;
            return pendingTransplantTotal + transplantedTotal;
        }

        return 0;
    }

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.columnApi = e.columnApi;
    }

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    };

    handleTabChange = (category: number) => {
        let tab = tabMap.find(x => x.id == category);

        let prefix = this.props.isSuperUser ? '/admin/donors/donor-shield-direct/' : '/center/' + this.props.centerId + '/donors/donor-shield-direct/';
        let newUrl = prefix + tab.section.toLowerCase();

        if (tab.section.toLowerCase() == "upload-lost-wage")
            newUrl = 'center/' + this.props.centerId + '/donors/watr/add-request'

        window.location.href = newUrl;
    }

    handleCancelDeleteDsDEntry = () => {
        this.setState({
            delete: {
                show: false,
                data: null
            }
        });
    }

    handleDeleteDsDEntry = () => {
        let donorShieldId = this.state.delete.data.id;
        let organType = this.props.app.site.organType == OrganType.Kidney ? null : this.props.app.site.organType;

        this.props.showLoading('Deleting donorShield entry, one moment please...').then(() => {
            this.props.deleteDonorShieldDirectRecord(donorShieldId)
                .then(response => {
                    if (response.data.success) {
                        let list = _.cloneDeep(this.state.list).filter(x => x.id !== donorShieldId);

                        this.setState({
                            list,
                            delete: {
                                show: false,
                                data: null
                            }
                        }, () => {
                            this.props.getDonorShieldDirectCounts(this.props.centerId, this.props.isSuperUser, organType)
                                .then(response => {
                                    if (response.data.success) {
                                        const counts = response.data.results;
                                        this.setState({ counts });
                                    }
                                });

                            this.props.hideLoading();
                            toast.success('Donor Shield record deleted successfully');
                        });
                    }
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                });
        });
    }

    handleActionRequest = (id: number, viewType: DonorShieldDirectViewType) => {
        let data = this.state.list.find(x => x.id === id);

        let prefix = '';

        switch (viewType) {
            case DonorShieldDirectViewType.EditDonor:
                let prefix = this.props.isSuperUser ? '/admin/donors/donor-shield-direct/' : '/center/' + this.props.centerId + '/donors/donor-shield-direct/';
                let newUrl = prefix + 'edit-donor/' + id + '';

                window.location.href = newUrl;

                break;

            case DonorShieldDirectViewType.DeleteDonor:
                let isAllowed = _.cloneDeep(this.state.list)
                    .filter(x => x.id === id)
                    .map(x => x.isBilled)[0] === false;

                if (!isAllowed) {
                    toast.error('Donor Shield entry has already been billed and cannot be deleted', { autoClose: false });
                    return;
                }

                this.setState({
                    delete: {
                        show: true,
                        data,
                    },
                });

                break;

            case DonorShieldDirectViewType.ApplyWage:
                let applyPrefix = this.props.isSuperUser ? '/admin/' + this.props.centerId + '/donors/watr/' : '/center/' + this.props.centerId + '/donors/watr/';
                let applyNewUrl = applyPrefix + 'add-request?donorShieldId=' + id;

                window.location.href = applyNewUrl;

                break;

            case DonorShieldDirectViewType.EditWageAndTravel:
                this.getRequestData(data.watrRequest);

                break;

            case DonorShieldDirectViewType.OrderStreamlinedSerology:
                window.location.href = '/center/' + this.props.centerId + '/action-center/home-blood-draw/streamlined-serology?donorShieldId=' + id;

                break;

            default:
                this.setState({
                    modal: {
                        type: viewType,
                        show: true,
                        data: data
                    },
                });

                break;
        }
    }

    handleUpdateDonorRequest = (requestId: number, firstName: string, lastName: string, email: string, mobile: string, birthDate: string, expirationDate: string,
        achAccountNumber: string, achRoutingNumber: string, intlBankingNumber: string, intlSwiftNumber: string,
        nameOfBank: string, cityTownLocality: string, stateProvinceRegion: string, postalCode: string, additionalCode: string) => {

        let request: IWatrUpdateDonorRequest = {
            requestId,
            firstName, middleInitial: '', lastName, email, mobile, birthDate, expirationDate: '',
            achAccountNumber, achRoutingNumber, intlBankingNumber, intlSwiftNumber,
            bankInformation: { nameOfBank, cityTownLocality, stateProvinceRegion, postalCode, additionalCode },
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: 0,
            postalCode: '',
            country: 0,
            countryOfCitizenship: 0,
            isAdmin: this.props.isSuperUser,
        };

        this.props.updateDonorRequest(request)
            .then(response => {
                if (response.data.success) {
                    let req = response.data.results;

                    let list = _.cloneDeep(this.state.list).map(item => {
                        if (item.watrRequest.id == req.id) {
                            item.watrRequest.firstName = req.firstName;
                            item.watrRequest.lastName = req.lastName;
                            item.watrRequest.email = req.email;
                            item.watrRequest.mobile = req.mobilePhone;
                            item.watrRequest.birthDate = req.birthDate;
                            item.watrRequest.expirationDate = req.expirationDate;
                            item.watrRequest.achAccountNumber = req.achAccountNumber;
                            item.watrRequest.achRoutingNumber = req.achRoutingNumber;
                            item.watrRequest.name = `${req.firstName} ${req.lastName}`;
                        }
                        return item;
                    });

                    this.setState({
                        list
                    })

                    this.props.hideLoading();

                    toast.success('Request updated successfully');
                }
            })
            .catch((error: AxiosError) => {
                this.props.hideLoading();
            });
    }

    handleCancelAdditionalInfoSidebar = () => {
        this.setState({
            additionalInfoSidebar: {
                show: false,
                data: null,
                displayType: 0,
                fileUrl: ''
            }
        });
    }

    handleCancelView = () => {
        this.setState({
            container: {
                show: false,
                data: null,
                reimbursements: null
            },
            additionalInfoSidebar: {
                show: false,
                data: null,
                displayType: 0,
                fileUrl: ''
            }
        });
    }

    showAdditionalInfoSidebar = (docType: number, lookupId: number, fileUrl: string) => {
        let show = this.state.additionalInfoSidebar.show;

        let displayType = null;

        if (docType != this.state.additionalInfoSidebar.displayType) {
            displayType = docType;
            show = true;
        } else {
            show = false
        }

        this.setState({
            additionalInfoSidebar: {
                show,
                data: this.state.additionalInfoSidebar.data,
                displayType,
                fileUrl
            },
        });
    }

    fetchFileUrl = (docType: FileDocumentType, lookupId: number): Promise<string> => {
        this.props.showLoading('Loading file...');

        return this.props.downloadFile(docType, lookupId)
            .then((response: any) => {
                const fileUrl = URL.createObjectURL(response.data);
                return fileUrl;
            })
            .catch((error) => {
                console.error('Error fetching file:', error);
                //throw error;
                return null;
            }).finally(() => {
                this.props.hideLoading();
            });
    }

    handleSaveLogEntry = (type: number, comments: string, file: File) => {
        let message = 'Creating log entry, one moment please...';
        let reqId = this.state.container.data.id;

        this.props.showLoading(message).then(() => {
            this.props.saveLogEntry(reqId, type, comments, file)
                .then(response => {
                    if (response.data.success) {

                        //get data in view
                        //update state of view
                        let viewData = _.cloneDeep(this.state.container.data);

                        if (viewData.logs == undefined)
                            viewData.logs = [];

                        viewData.logs.push(response.data.results);

                        this.setState({
                            container: {
                                show: true,
                                data: viewData,
                                reimbursements: this.state.container.reimbursements
                            }
                        }, () => {
                            this.props.hideLoading();
                            toast.success('Log entry updated successfully');
                        });
                    } else {
                        this.props.hideLoading();
                        toast.error('Unable to create entry');
                    }
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleUpdateLogEntry = (logId: number, type: number, comments: string, file: File) => {
        let message = 'Creating log entry, one moment please...';
        let reqId = this.state.container.data.id;

        this.props.showLoading(message).then(() => {
            this.props.updateLogEntry(reqId, logId, type, comments, file)
                .then(response => {
                    if (response.data.success) {
                        let logId = response.data.results.id;

                        let list = _.cloneDeep(this.state.list).map(item => {
                            if (item.id == reqId) {
                                item.watrRequest.logs = item.watrRequest.logs.map(logItem => {
                                    if (logItem.id == logId)
                                        return response.data.results;

                                    return logItem;
                                })
                            }

                            return item;
                        });

                        let data = list.find(x => x.id == reqId);

                        this.setState({
                            list,
                            container: {
                                show: true,
                                data: data.watrRequest,
                                reimbursements: this.state.container.reimbursements
                            }
                        }, () => {
                            this.props.hideLoading();
                            toast.success('Log entry updated successfully');
                        });
                    } else {
                        toast.error('Unable to create entry');
                    }

                    this.props.hideLoading();
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleDeleteLogEntry = (logId: number) => {
        let reqId = this.state.container.data.id;

        this.props.showLoading('Deleting log entry, one moment please...').then(() => {
            this.props.deleteLogEntry(reqId, logId)
                .then(response => {
                    if (response.data.success) {
                        let list = _.cloneDeep(this.state.list).map(item => {
                            if (item.id == reqId) {
                                item.watrRequest.logs = item.watrRequest.logs.filter(logItem => logItem.id != logId);
                            }
                            return item;
                        });

                        let data = list.find(x => x.id == reqId);

                        this.setState({
                            list,
                            container: {
                                show: true,
                                data: data.watrRequest,
                                reimbursements: this.state.container.reimbursements
                            }
                        }, () => {
                            this.props.hideLoading();
                            toast.success('Log entry delete successfully');
                        });
                    }
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleReimbursementEntry = (type: number, amount: number, confirmationCode: string, date: string) => {
        let message = 'Adding reimbursement entry, one moment please...';

        this.props.showLoading(message).then(() => {
            this.props.saveReimbursementEntry(this.state.container.data.id, type, amount, confirmationCode, date)
                .then(response => {
                    let reimbursements = _.cloneDeep(this.state.container.reimbursements).map(item => {
                        return item;
                    });

                    reimbursements.push(response.data.results.newReimbursement);

                    var status = response.data.results.newRequestStatus;

                    let requestList = _.cloneDeep(this.state.list).map(item => {
                        if (item.watrRequest.id == this.state.container.data.id) {
                            item.watrRequest.status = status;
                        }

                        return item;
                    });

                    this.setState({
                        list: requestList,
                        container: {
                            show: true,
                            data: this.state.container.data,
                            reimbursements: this.state.container.reimbursements
                        }
                    }, () => {
                        this.getData(this.state.category, true);
                        this.props.hideLoading();
                        toast.success('Reimbursement added successfully');
                    });
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleReimbursementUpdate = (requestId: number, reimbursementId: number, type: number, amount: number, confirmationCode: string, date: string) => {
        let message = 'Updating reimbursement entry, one moment please...';

        this.props.showLoading(message).then(() => {
            this.props.updateReimbursement(requestId, reimbursementId, type, amount, confirmationCode, date)
                .then(response => {
                    let results = response.data.results;

                    let reimbursements = _.cloneDeep(this.state.container.reimbursements).map(item => {
                        if (item.id == reimbursementId) {
                            item.amount = results.amount;
                            item.confirmationCode = results.confirmationCode;
                            item.date = results.date;
                            item.reimbursementType = results.reimbursementType;
                        }

                        return item;
                    });

                    this.setState({
                        container: {
                            show: true,
                            data: this.state.container.data,
                            reimbursements: reimbursements
                        }
                    }, () => {
                        this.props.hideLoading();
                        toast.success('Reimbursement updated successfully');
                    });
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    getRequestData = (data: IWatrRequest) => {
        this.props.showLoading('Loading data...').then(() => {
            this.props.getTravelDetails(this.props.centerId, data.id, this.props.isSuperUser)
                .then(response => {
                    if (response.data.success) {
                        let { watrReimbursements, watrTravelLogs } = response.data.results;

                        data.logs = watrTravelLogs.length == 1 ? watrTravelLogs : _.orderBy(watrTravelLogs, ['logDate'], 'desc');

                        this.setState({
                            container: {
                                show: true,
                                data,
                                reimbursements: watrReimbursements
                            }
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    render = () => {
        const total = this.getTotal();

        const contextValue: IDonorShieldContext = {
            isNkrSuper: this.props.isSuperUser,
            currentUser: this.props.app.user,
            auditLogTypes: this.state.auditLogTypes,
            logActionTypes: this.state.logActionTypes,
            donationTypes: this.state.donationTypes,
            reimbursementTypes: this.state.reimbursementTypes,
            statusTypes: this.state.statusTypes,
            requestTypes: this.state.requestTypes,
            onShowDataSideBar: this.showAdditionalInfoSidebar,
            fetchFileUrl: this.fetchFileUrl,
            downloadFile: this.props.downloadFile,
            handleSaveLogEntry: this.handleSaveLogEntry,
            handleUpdateLogEntry: this.handleUpdateLogEntry,
            handleDeleteLogEntry: this.handleDeleteLogEntry,
            onReimbursementEntry: this.handleReimbursementEntry,
            onReimbursementUpdate: this.handleReimbursementUpdate,
            onShowDeclineModal: () => null,
            onUpdateTitle: () => null,
            onVerifyPayStub: () => null,
            onVerifyTax: () => null,
            onVerifyTravel: () => null,
            onVerifyAmount: () => null
        };

        return (
            <>
                <Filters
                    isNkrAdmin={this.props.isSuperUser}
                    centerId={this.props.centerId}
                    activeTab={this.state.category}
                    counts={this.state.counts}
                    onTabChange={this.handleTabChange}
                />

                <Grid
                    list={this.state.list}
                    isLoading={this.state.isLoadingList}
                    isSuperUser={this.props.isSuperUser}
                    gridApi={this.gridApi}
                    columnApi={this.columnApi}
                    selectedTab={this.state.category}
                    onActionRequest={this.handleActionRequest}
                    onSetGridComponents={this.onGridReady}
                />

                <DonorShieldProvider value={contextValue}>
                    <MediaQuery minWidth={1023} style={{ padding: 0 }}>
                        <div ref={this.saveContainer}>
                            <Sidebar
                                data={this.state.container.data}
                                reimbursements={this.state.container.reimbursements}
                                type={WageAndTravelViewType.RequestData}
                                show={this.state.container.show}
                                onUpdateDonorRequest={this.handleUpdateDonorRequest}
                                onCancelView={this.handleCancelView}
                                getContainer={this.getContainer}
                                updateAudit={() => null} />

                            <AdditionalInfoSidebar
                                data={this.state.additionalInfoSidebar.data}
                                centerId={this.props.centerId}
                                show={this.state.additionalInfoSidebar.show}
                                displayType={this.state.additionalInfoSidebar.displayType}
                                fileUrl={this.state.additionalInfoSidebar.fileUrl}
                                getContainer={this.getContainer}
                                onCancelView={this.handleCancelAdditionalInfoSidebar}
                            />
                        </div>
                    </MediaQuery>
                </DonorShieldProvider>

                <div style={{ marginBottom: 5 }}>{this.state.list.length} of {total} records shown...</div>

                <DeleteConfirmation
                    show={this.state.delete.show}
                    data={this.state.delete.data}
                    container={this}
                    onDelete={this.handleDeleteDsDEntry}
                    onCancel={this.handleCancelDeleteDsDEntry}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getDonorShieldDirectList: (centerId, matchStatus, isAdmin, organType) => {
            return dispatch(DonorShieldDirectActionCreators.getDonorShieldDirectList(centerId, matchStatus, isAdmin, organType));
        },
        getDonorShieldDirectCounts: (centerId, isAdmin, organType) => {
            return dispatch(DonorShieldDirectActionCreators.getRequestCounts(centerId, isAdmin, organType));
        },
        addDonorShieldDirectRecord: (dsdData) => {
            return dispatch(DonorShieldDirectActionCreators.addDonorShieldDirectRecord(dsdData));
        },
        updateDonorShieldDirectRecord: (requestId, dsdData) => {
            return dispatch(DonorShieldDirectActionCreators.updateDonorShieldDirectRecord(requestId, dsdData));
        },
        deleteDonorShieldDirectRecord: (donorshieldRecord) => {
            return dispatch(DonorShieldDirectActionCreators.deleteDonorShieldDirectRecord(donorshieldRecord));
        },
        updateDonorRequest: (request) => {
            return dispatch(WatrActionCreators.updateDonorRequest(request));
        },
        downloadFile: (docType, lookupId) => {
            return dispatch(FileActionCreators.downloadFile(docType, lookupId));
        },
        saveReimbursementEntry: (requestId, type, amount, confirmationCode, date) => {
            return dispatch(WatrActionCreators.createReimbursement(requestId, type, amount, confirmationCode, date));
        },
        updateReimbursement: (requestId, reimbursementId, type, amount, confirmationCode, date) => {
            return dispatch(WatrActionCreators.updateReimbursement(requestId, reimbursementId, type, amount, confirmationCode, date));
        },
        saveLogEntry: (requestId, type, comments, file) => {
            return dispatch(WatrActionCreators.createAuditLog(requestId, type, comments, file));
        },
        updateLogEntry: (requestId, logId, type, comments, file) => {
            return dispatch(WatrActionCreators.updateAuditLog(requestId, logId, type, comments, file));
        },
        deleteLogEntry: (requestId, logId) => {
            return dispatch(WatrActionCreators.deleteAuditLog(requestId, logId));
        },
        getTravelDetails: (centerId, requestId, isAdmin) => {
            return dispatch(WatrActionCreators.getTravelDetails(centerId, requestId, isAdmin));
        },
        getRequestLookupData: () => {
            return dispatch(WatrActionCreators.getLookupData());
        },
    }
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(DonorShieldDirect);